import type { HowToPlayPageData } from "@/components/HowToPlayPage";

export const cash4lifeHowToPlayData: HowToPlayPageData = {
  meta: {
    title: "How to Play Cash4Life: Rules & Prizes",
    description: "Learn how to play Cash4Life. Understand the rules, top prize of $1,000 a day for life, all 9 prize tiers, jackpot odds, and how to claim winnings.",
    canonical: "https://usalotteryclub.com/cash4life/how-to-play",
  },
  gameName: "Cash4Life",
  gameSlug: "cash4life",
  heroDescription: "Cash4Life is a multi-state lottery offered in 10 states across the U.S. Northeast, Midwest, and South. Drawings are held every night at 9:00 p.m. Eastern Time. The top prize is $1,000 a day for life, and the second prize is $1,000 a week for life — paid in either guaranteed annuity payments or a one-time lump-sum cash option.",
  keyFacts: ["$2 per play", "Drawn nightly", "Top prize $1,000/day for life", "9 ways to win"],
  steps: [
    { title: "Pick your white ball numbers", description: "Choose five different numbers from 1 to 60." },
    { title: "Pick your Cash Ball number", description: "Choose one Cash Ball number from 1 to 4." },
    { title: "Use Quick Pick if you prefer", description: "Mark Quick Pick on your playslip and the terminal will randomly select all six numbers for you." },
    { title: "Buy your ticket", description: "A Cash4Life ticket costs $2 per play. You can buy tickets for up to 7 consecutive drawings (varies by state)." },
    { title: "Check the results", description: "Drawings are held nightly at 9:00 p.m. Eastern Time. Find the latest winning numbers right here on USA Lottery Club after each draw." },
  ],
  prizeTiersIntro: "There are 9 ways to win a Cash4Life prize. The overall odds of winning any prize are 1 in 7.76.",
  prizeTiers: [
    { match: "5 white balls + Cash Ball", prize: "$1,000 a day for life", odds: "1 in 21,846,048" },
    { match: "5 white balls", prize: "$1,000 a week for life", odds: "1 in 7,282,016" },
    { match: "4 white balls + Cash Ball", prize: "$2,500", odds: "1 in 79,440" },
    { match: "4 white balls", prize: "$500", odds: "1 in 26,480" },
    { match: "3 white balls + Cash Ball", prize: "$100", odds: "1 in 1,471" },
    { match: "3 white balls", prize: "$25", odds: "1 in 490" },
    { match: "2 white balls + Cash Ball", prize: "$10", odds: "1 in 83" },
    { match: "1 white ball + Cash Ball", prize: "$4", odds: "1 in 13" },
    { match: "Cash Ball only", prize: "$2", odds: "1 in 8" },
  ],
  jackpotTitle: "How the Cash4Life Top Prize Works",
  jackpotDescription: "The top prize is $1,000 a day for life ($365,000 per year, guaranteed for life or 20 years — whichever is greater). The second prize is $1,000 a week for life ($52,000 per year, on the same terms). Winners may choose annuity or a one-time lump-sum cash payment instead.",
  jackpotOptions: [
    { label: "Annuity (lifetime)", description: "$1,000 every day for the rest of your life, guaranteed for a minimum of 20 years." },
    { label: "Cash (Lump Sum)", description: "A single one-time payment of $7,000,000 in lieu of the lifetime annuity (or $1,000,000 for the second prize)." },
  ],
  jackpotFootnote: "If multiple tickets match all six winning numbers, prizes may be paid as a one-time cash payment divided equally among winners. Check your state lottery's rules.",
  drawSchedule: [
    { day: "Every day", time: "9:00 p.m. ET" },
  ],
  drawScheduleNote: "Ticket sales close before each drawing — cutoff times vary by state. Check with your local lottery for exact cutoff times.",
  claimRules: [
    "Small prizes (typically under $600): Claim at any authorized lottery retailer.",
    "Prizes $600 and above: Complete a claim form and present at a lottery office or by mail.",
    "Top prize: Must be claimed in person at the lottery headquarters in the state where the winning ticket was purchased.",
    "Claim deadline: Usually 180 days to 1 year from the drawing date — varies by state.",
  ],
  claimNote: "Sign the back of your ticket immediately. All prizes must be claimed in the state where the ticket was purchased.",
  taxTitle: "Cash4Life Taxes",
  taxSections: [
    { heading: "Federal withholding", text: "The IRS requires 24% to be withheld automatically from prizes over $5,000." },
    { heading: "State taxes", text: "Most participating states withhold state income tax on top prizes. Rates vary by state." },
    { heading: "Annuity vs. lump sum taxes", text: "Annuity payments are taxed each year you receive them. The lump-sum cash option is taxed in full in the year you receive it." },
  ],
  taxCta: "Use our Tax Calculator to estimate your take-home amount →",
  quickFacts: [
    { label: "Ticket price", value: "$2 per play" },
    { label: "White ball range", value: "1–60" },
    { label: "Cash Ball range", value: "1–4" },
    { label: "Drawing days", value: "Every day" },
    { label: "Drawing time", value: "9:00 p.m. ET" },
    { label: "Top prize", value: "$1,000 a day for life" },
    { label: "Second prize", value: "$1,000 a week for life" },
    { label: "Overall odds", value: "1 in 7.76" },
    { label: "Top prize odds", value: "1 in 21,846,048" },
    { label: "Ways to win", value: "9" },
  ],
  faqs: [
    { question: "How much does a Cash4Life ticket cost?", answer: "A Cash4Life ticket costs $2 per play." },
    { question: "When are Cash4Life drawings?", answer: "Cash4Life drawings are held every night at 9:00 p.m. Eastern Time." },
    { question: "What does \"for life\" really mean?", answer: "Winners are guaranteed a minimum of 20 years of payments, even if they pass away before then — payments continue to their estate." },
    { question: "Can I take a lump sum instead?", answer: "Yes. Winners may choose a one-time cash payment in lieu of lifetime annuity payments." },
    { question: "Which states play Cash4Life?", answer: "Cash4Life is currently offered in New York, New Jersey, Pennsylvania, Virginia, Florida, Georgia, Indiana, Maryland, Missouri, and Tennessee." },
  ],
  disclaimer: "Results are unofficial. Always verify winning numbers with your official state lottery. USA Lottery Club is independent and not affiliated with Cash4Life or any state lottery.",
};